<script>
  import { HorizontalBar, mixins } from 'vue-chartjs'
  import { Bus } from '@/components/Bus'

  export default {
    extends: HorizontalBar,
    mixins: [mixins.reactiveData],
    props: ['data', 'options'],
    mounted() {
      this.renderChart(this.data, this.options)

      Bus.$on('openChart', () => {
        this.$nextTick(() => {
          this.renderChart(this.data, this.options)
        })
      })
    },
    beforeDestroy() {
      Bus.$off('openChart')
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Chart.vue